export default "__VITE_ASSET__2b5e8f0c__"